import { useProductPageContext } from "shared/product/ProductPageContext/useProductPageContext";
import { useI18n } from "utils/with-i18n.utils";

import { AccessoryCard } from "./AccessoryCard";

export const SuppliedAccessoriesSection = () => {
  const i18n = useI18n();
  const { suppliedAccessories } = useProductPageContext();

  return (
    <div className="flex flex-col gap-4 items-center py-12 px-2 bg-white lg:gap-6 lg:py-20 lg:px-8">
      <h2 className="text-3xl font-medium text-center lg:text-6xl">
        {i18n.t("product.suppliedAccessoriesSection.title")}
      </h2>
      <div className="flex flex-wrap gap-4 justify-center items-center lg:gap-6">
        {suppliedAccessories?.map(({ image, name, sku }) => (
          <AccessoryCard key={sku} name={name ?? undefined} image={image} />
        ))}
      </div>
    </div>
  );
};
